import React from "react";
import ReactDOM from "react-dom";

type Props = {
    languages: Array<string>;
    language: null | string;
    onChange: (language: string) => void;
};

export default class ExampleHeader extends React.Component<Props> {
    public headerNode: Element | null = null;

    public componentDidMount(): void {
        this.headerNode = document.querySelector(".examples-header");
    }

    public onClick = (language: string): void => {
        this.props.onChange(language);
    };

    public render(): React.ReactNode {
        if(!this.headerNode) {
            return null;
        }

        const { languages, language } = this.props;

        return ReactDOM.createPortal(
            <div className="languages">
                {languages.map(lang => {
                    const selected = lang === language;

                    return (
                        <div
                            key={lang}
                            className={"language" + (selected ? " selected" : "")}
                            onClick={this.onClick.bind(this, lang)}
                        >
                            <span>{lang}</span>
                        </div>
                    );
                })}
            </div>,
            this.headerNode
        );
    }
}
